import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useDisconnectLinkedin(
  tenant: number,
  options: UseMutationOptions = {}
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await axios.delete(`${getBongoUrl()}/v1/org/${tenant}/integrations/linkedin`);
    },
    onSuccess: (...args) => {
      queryClient.setQueryData(['linkedin', tenant], false);
      queryClient.invalidateQueries(['linkedin-credentials', tenant]);
      options?.onSuccess?.(...args);
    },
  });
}
